<!-- @format -->

<div class="ssg-name">
  {{ studySubGroup.name | localizedString }}
  @if (studySubGroup.cancelled) {
    <span class="tiny-badge danger" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.CANCELLED"> </span>
  }
</div>

<span class="teacher-time-header" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.TEACHERS_TITLE"></span>

<div class="teachers">
  @for (teacherId of studySubGroup.teacherIds; track teacherId) {
    <span class="teacher-name">
      <sis-icon icon="person"></sis-icon>
      <span class="teacher">{{ teacherId | publicPerson | async | personFullName }}</span>
    </span>
  }
  @if (!studySubGroup.teacherIds || studySubGroup.teacherIds.length === 0) {
    <span class="no-teacher">
      <sis-icon icon="person"></sis-icon>
      <span class="teacher" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.NO_TEACHER"></span>
    </span>
  }

  @if (studySubGroupHasTeacherOverrides) {
    <div class="irregularities"> (<span translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.IRREGULAR_TEACHERS"></span>) </div>
  }
</div>

<div class="study-sub-group-info">
  <span class="teacher-time-header" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.STUDY_EVENTS_TITLE"></span>

  @if (!sortedStudyEvents || sortedStudyEvents.length === 0) {
    <div class="no-events" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.NO_STUDY_EVENT"> </div>
  }
  @for (studyEvent of sortedStudyEvents; track studyEvent) {
    <div>
      <sis-study-sub-group-structure-study-event
        [studyEvent]="studyEvent"
        [language]="language"
        [teacherIds]="studySubGroup.teacherIds"></sis-study-sub-group-structure-study-event>
    </div>
  }
</div>
